import React, { useState } from 'react';
import Project from './Project';
import { ProjectsData } from './ProjectData'
import SwiperCore, { Swiper, SwiperSlide, useSwiper } from 'swiper/react';
import { FreeMode, Autoplay, Pagination } from "swiper";


import "swiper/css";
import ViewDetails from './VeiwDetails';
import Social from '../social/Social';
const Projects = () => {
    const [ViewHtmlDetails, setViewHtmlDetails] = useState(null);
    return (
        <div id='Projects' className=' bg-base-200 rounded-lg shadow-inner m-5 p-5 h-full'>
            <h1 className="text-3xl md:text-5xl text-center font-bold text-white ">My latest work</h1>
            <div className="divider"></div>

            <div className=' mt-7'>
                <Swiper
                    pagination={{
                        clickable: true,
                    }}
                    autoplay={{
                        delay: 2500,
                        disableOnInteraction: false,
                    }}
                    modules={[FreeMode, Autoplay, Pagination]}
                    effect="coverflow"
                    grabCursor="true"
                    centeredSlides="true"
                    spaceBetween={0}
                    slidesPerView={4}
                    loop="true"
                    coverflowEffect={{
                        rotate: 20,
                        stretch: 25,
                        depth: 250,
                        modifier: 1,
                        slideShadows: false,
                    }}
                    breakpoints={{
                        1100: {
                            spaceBetween: 150,
                            slidesPerView: 3,
                        },
                        1024: {
                            spaceBetween: 250,
                            slidesPerView: 3,
                        },
                        800: {
                            spaceBetween: 90,
                            slidesPerView: 2,
                        },
                        700: {
                            spaceBetween: 200,
                            slidesPerView: 2,
                        },
                        500: {
                            spaceBetween: 100,
                            slidesPerView: 1,
                        },
                        411: {
                            spaceBetween: 100,
                            slidesPerView: 1,
                        },
                        300: {
                            spaceBetween: 100,
                            slidesPerView: 1,
                        },
                    }}
                >

                    {
                        ProjectsData.map((project, index) =>
                            <SwiperSlide key={index}>
                                <Project project={project} setViewHtmlDetails={setViewHtmlDetails} />
                            </SwiperSlide>
                        )
                    }
                </Swiper>
                <div className='text-center mt-2'>
                    <div class="badge badge-outline badge-xs m-1"></div>
                    <div class="badge badge-outline badge-xs m-1"></div>
                    <div class="badge badge-outline badge-xs m-1"></div>
                </div>
            </div>
            <Social/>
            {
                ViewHtmlDetails && <ViewDetails props={{ ViewHtmlDetails, setViewHtmlDetails }} />
            }
        </div >
    );
};

export default Projects;